import { ArrowLeftOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Flex, App } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { CompanyList } from '../utils';

function Header({ id }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [nextId, setNextId] = useState(null);
  const [prevId, setPrevId] = useState(null);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      CompanyList.getNext(id).then((nextId) => {
        setNextId(nextId);
      }),
      CompanyList.getPrevId(id).then((prevId) => {
        setPrevId(prevId);
      }),
    ]).finally(() => setLoading(false));
  }, [id]);

  return (
    <Flex
      justify="space-between"
      className="sticky top-0 z-10 py-4 flex-col md:flex-row items-start md:items-center gap-2 bg-white"
    >
      <Flex
        onClick={() => navigate(-1)}
        gap={8}
        align="center"
        className="cursor-pointer text-[#717679]"
      >
        <ArrowLeftOutlined />
        <span className="font-weight-bolder">Companies</span>
      </Flex>

      <Flex gap={8}>
        <Button
          onClick={() => navigate(`/console/companies/${prevId}/info`)}
          disabled={!prevId || loading}
        >
          <LeftOutlined />
          Previous
        </Button>

        <Button
          onClick={() => navigate(`/console/companies/${nextId}/info`)}
          disabled={!nextId || loading}
        >
          Next
          <RightOutlined />
        </Button>
      </Flex>

    </Flex>
  );
}

export default Header;
